import type { ConversationAction } from '@atlassian/rovo-conversation-actions/types';

import { getConversationActionWithAssistantMetadata } from './getConversationActionWithAssistantMetadata';

export const getActionFollowUps = (action: ConversationAction | undefined): string[] =>
	getConversationActionWithAssistantMetadata(action)?.followUps ?? [];
